import { ReactNode } from 'react';

type SummaryHighlightProps = {
  label: string;
  children: ReactNode;
  className?: string;
  first?: boolean;
};

export const SummaryHighlight: React.FC<SummaryHighlightProps> = ({
  label,
  children,
  className = '',
  first = false,
}) => {
  return (
    <div className="flex items-center shrink-0">
      {!first && <div className="h-5 w-px bg-neutral-300 mr-6 self-center" />}
      <div className={`pr-6 ${className}`}>
        <div className="uppercase text-neutral-500 text-sm font-semibold">{label}</div>
        <div className="font-bold text-neutral-900 text-base">{children}</div>
      </div>
    </div>
  );
};
